import React from 'react';
import { StyleSheet } from './base_components';
import TitleActionLine from './title_action_line';

import StandardBoxList from './standard_box_list';
import Checkbox from './checkbox';
import TextButton from './buttons/text_button';
import PropList from './prop_list';

import MediaIngest from '../lib/media_ingest';

import { byteFormat } from '../tools/util';

const styles = StyleSheet.create({
  checkbox: {
    marginTop: '1.5rem',
    marginLeft: '3rem',
    color: '#181820',
    fontSize: '1.4rem',
    fontWeight: '500',
  },
});

export default function UploadProgress(props) {
  const list = MediaIngest.useUploadList();
  const summary = MediaIngest.useSummary();

  let status = '';
  let detail = '';
  let success = '';
  let skipped = '';
  let failure = '';
  if (summary) {
    const { file_count, success_count, fail_count, skip_count } = summary;
    const { total_size, success_size, fail_size, skip_size } = summary;
    detail = `${file_count} Total, ${byteFormat(total_size)}`;
    success = `${success_count} files, ${byteFormat(success_size)}`;
    skipped = `${skip_count} files, ${byteFormat(skip_size)}`;
    failure = `${fail_count} files, ${byteFormat(fail_size)}`;
    if (summary.is_running) {
      status = 'Running';
    } else {
      status = fail_count > 0 ? `Done - ${fail_count} Failed` : 'Success';
    }
  }
  let button: any = null;
  if (!summary?.is_running && summary.fail_count > summary.fatal_count) {
    button = <TextButton text='Retry' onPress={props.onRetry} />;
  } else if (!summary?.is_running) {
    button = <TextButton text='Close' onPress={props.onClose} />;
  }

  const rows = list.map((upload) => {
    return {
      list: [
        upload.name,
        upload.dir || '-',
        byteFormat(upload.file_size),
        _status(upload),
        _error(upload) || '-',
      ],
    };
  });
  return (
    <>
      <TitleActionLine title={`Upload: ${status}`}>{button}</TitleActionLine>
      <Checkbox
        style={styles.checkbox}
        text='Automated Retry'
        value={props.retryForever}
        onChange={props.onRetryChange}
      />
      <StandardBoxList title='Summary'>
        <PropList
          columns={[
            [{ label: 'Destination', value: summary?.path }],
            [
              { label: 'Succeeded', value: success },
              { label: 'Skipped', value: skipped },
            ],
            [{ label: 'Failed', value: failure }],
          ]}
        />
      </StandardBoxList>
      <StandardBoxList
        title='Files'
        detail={detail}
        headers={['Name', 'Folder', 'Size', 'Status', 'Error']}
        sizes={[1, 1, 1, 1, 3]}
        rows={rows}
      />
    </>
  );
}
function _status(upload): string {
  switch (upload.status) {
    case 'idle':
      return 'Waiting';
    case 'start':
      return 'Start';
    case 'hashing':
      return 'Hashing';
    case 'hash_done':
      return 'Hashing Done';
    case 'waiting_retry':
      return 'Waiting to Retry';
    case 'done':
      return 'Done';
    case 'uploading':
      return (upload.progress * 100).toFixed(2) + '%';
    case 'error':
      return 'Failed';
  }
  return String(upload.status);
}
function _error(upload: any): string {
  switch (upload?.last_err) {
    case 'conflict':
      return 'Different file already exists in the volume.';
    case 'request_failure':
      return 'Network failure';
  }
  if (upload?.last_err) {
    return String(upload.last_err);
  }
  return '';
}
